<template>
  <div class="container">

    <form class="form-horizontal">
      
      <div class="form-group">
        <div class="col-12">
          <div class="input-group">
            <avatar :user="user"></avatar>
            <button v-if="editing && user.profile.avatar" class="btn btn-link" @click="delAvatar">Delete</button>
          </div>
        </div>
      </div>

      <div v-if="editing" class="form-group">
        <div class="col-3">
          <label class="form-label">New avatar</label>
        </div>
        <div class="col-9">
          <div class="input-group">

            <image-uploader
              :maxWidth="128"
              :maxHeight="128"
              :quality="0.9"
              :preview="true"
              :className="['form-input']"
              @input="setPic"
            ></image-uploader>

          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-3">
          <label class="form-label">Brand</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <select class="form-select" v-model="user.profile.brand">
              <option v-for="(v,k) in brands" :value="k">{{v}}</option>
            </select>
          </div>
          <div v-else>
            <!-- <label class="form-label">{{user.profile.brand}}</label> -->
            <label class="form-label">{{getBrand()}}</label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-3">
          <label class="form-label">First name</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.firstname" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.firstname}}</label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-3">
          <label class="form-label">Last name</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.lastname" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.lastname}}</label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-3">
          <label class="form-label">Date of birth</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="dob_d" placeholder="DD" />
            <input class="form-input" type="text" v-model="dob_m" placeholder="MM" />
            <input class="form-input" type="text" v-model="dob_y" placeholder="YYYY" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.dob}}</label>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="col-3">
          <label class="form-label">Email</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="email" v-model="user.email" />
          </div>
          <div v-else>
            <label class="form-label">{{user.email}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Phone</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="tel" v-model="user.profile.phone" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.phone}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Business</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.business" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.business}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Corporate client</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <label class="form-checkbox">
              <input type="checkbox" v-model="user.profile.corporate">
              <i class="form-icon"></i>
            </label>
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.corporate ? 'Yes' : 'No'}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Address line 1</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.address1" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.address1}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Address line 2</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.address2" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.address2}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Suburb</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.suburb" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.suburb}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Postcode</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.postcode" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.postcode}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">State</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <select v-if="user.profile.country === 'AUSTRALIA'" class="form-select" v-model="user.profile.state" style="width:100%;">
              <option value="ACT">ACT</option>
              <option value="NSW">NSW</option>
              <option value="QLD">QLD</option>
              <option value="NT">NT</option>
              <option value="TAS">TAS</option>
              <option value="VIC">VIC</option>
              <option value="WA">WA</option>
            </select>
            <input v-else class="form-input" type="text" v-model="user.profile.state" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.state}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Passport number</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.passport" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.passport}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Country</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <select class="form-select" v-model="user.profile.country">
              <option value="">Select</option>
              <option v-for="(v,k) in countries" :value="k">{{k}}</option>
            </select>
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.country}}</label>
          </div>
        </div>
      </div>

      <div v-if="isEdAdmin && isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Cost agreement</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <div v-if="user.agreement">
              <button class="btn" @click="unlinkAgreement">Unlink</button>
            </div>
            <select v-else class="form-select" v-model="newAgreement" style="width:100%;">
              <option v-for="a in agreements" :value="a._id">{{a.name}} ({{a.email}})</option>
            </select>
          </div>
          <div v-else>
            <router-link v-if="user.agreement" :to="'/agreements/' + user.agreement">View</router-link>
            <label v-else class="form-label">N/A</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">Client source</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <select class="form-select" v-model="user.profile.source">
              <option value="">Select</option>
              <option v-for="s in sources" :value="s">{{s}}</option>
            </select>
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.source}}</label>
          </div>
        </div>
      </div>

      <div v-if="isUserClient" class="form-group">
        <div class="col-3">
          <label class="form-label">More details</label>
        </div>
        <div class="col-9">
          <div v-if="editing" class="input-group">
            <input class="form-input" type="text" v-model="user.profile.details" />
          </div>
          <div v-else>
            <label class="form-label">{{user.profile.details}}</label>
          </div>
        </div>
      </div>


      <div class="col-12">
        <span v-if="successMsg" class="label label-success">{{successMsg}}</span>
        <span v-if="error" class="label label-error">{{error}}</span>
      </div>
      <div v-if="showButtons" class="form-group">
        <div v-if="isEdAdmin" class="col-12 adminControls">
          <button v-if="!editing" class="btn btn-primary" @click.prevent="editMode">Edit</button>
          <button v-if="editing" class="btn btn-primary" :class="{loading: wait1}" @click.prevent="save">Save</button>
          <button v-if="!user.verified && !editing" class="btn btn-primary" :class="{loading: wait2}" @click="invite">
            Invite
          </button>
          <button v-if="user.level === 6" class="btn btn-primary" @click.prevent="toLevel(5)">Make full client</button>
          <button v-if="user.level === 5" class="btn btn-primary" @click.prevent="toLevel(6)">Make prospect</button>
          <button v-if="!editing" class="btn btn-primary" @click.prevent="archiveUser">
            {{ user.archived ? 'Unarchive' : 'Archive' }}
          </button>
          <button v-if="!editing" class="btn btn-primary" @click.prevent="showDelModal = true">Delete</button>
        </div>
        <div v-else class="col-12">
          <button v-if="!editing" class="btn btn-primary" @click.prevent="editMode">Edit</button>
          <button v-if="editing" class="btn btn-primary" :class="{loading: wait1}" @click.prevent="save">Save</button>
        </div>  
      </div>
    </form>

    <!-- DELETE USER MODAL -->
    <div class="modal" :class="{active: showDelModal}">
      <div class="modal-overlay"></div>
      <div class="modal-container">
        <div class="modal-body">
          <div class="content">
            Are you sure?
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" @click="delUser">Yes</button>
          <button class="btn" @click="showDelModal = false">No</button>
        </div>
      </div>
    </div>
    <!-- END MODAL -->

  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
import avatar from '@/components/users/avatar'
import { bus } from '@/components/bus.js'
import { ImageUploader } from 'vue-image-upload-resize'

export default {
  name: 'userProfile',
  props: ['user'],
  components: {
    avatar,
    ImageUploader
  },
  mixins: [utils],
  data () {
    return {
      countries: utils.countries(),
      sources: utils.sources(),
      brands: utils.brands(),
      agreements: [],
      newAgreement: '',
      editing: false,
      newPic: null,
      successMsg: '',
      error: '',
      savingPic: false,
      showDelModal: false,
      showButtons: true,
      wait1: false, // saving
      wait2: false, // inviting
      dob_y: '',
      dob_m: '',
      dob_d: ''
    }
  },
  created () {
    let title = ''
    let p = this.user.profile
    if (p.corporate) {
      title = p.business
    } else {
      title = p.firstname + ' ' + p.lastname
    }
    this.$root.$data.pageTitle = title

    // Set the dob fields
    if (p.dob && /^\d{2}-\d{2}-\d{4}$/.test(p.dob)) {
      let dmy = p.dob.split('-')
      this.dob_d = dmy[0]
      this.dob_m = dmy[1]
      this.dob_y = dmy[2]
    }
  },
  computed: {
    // Is the editing user an admin?
    isEdAdmin () {
      return this.$root.$data.admin
    },
    // Is the user being edited an admin?
    isUserClient () {
      return this.user.level > 4
    }
  },
  methods: {
    editMode () {
      if (this.isEdAdmin && this.isUserClient) {
        // Load the agreements if an admin is editing a client's profile
        this.getAgreements()
      }
      this.editing = true
    },
    save () {
      if (this.newAgreement) {
        // A new agreement has been chosen, so tell the server to link it to the client
        this.user.agreement = this.newAgreement
        this.linkAgreement()
      }
      this.wait1 = true

      // Set the date of birth: 'dd-mm-yyyy'
      this.user.profile.dob = [this.dob_d, this.dob_m, this.dob_y].join('-')

      axios.post('/api/users/update', this.user)
      .then(res => {
        if (res.status === 200) {
          this.error = ''
          if (this.newPic) {
            this.savePic()
          }
          this.editing = false
          this.wait1 = false
          this.successMsg = 'Saved'
          this.newAgreement = ''
          // utils.methods.delay(3000, () => { this.successMsg = '' })
        }
      })
      .catch(e => {
        this.editing = false
        this.wait1 = false
        this.error = e.response.data
        utils.methods.delay(3000, () => { this.error = '' })
      })
    },
    delUser () {
      axios.post('/api/users/delete/' + this.user._id)
      .then(res => {
        if (res.status === 200) {
          this.error = ''
          this.successMsg = 'Deleted'
          this.showButtons = false
          this.showDelModal = false
          utils.methods.delay(3000, () => { this.$router.go(-1) })
        }
      })
      .catch(e => {
        this.error = e.response.data
        this.showDelModal = false
        utils.methods.delay(3000, () => { this.error = '' })
      })
    },
    invite () {
      this.error = ''
      this.wait2 = true
      axios.post('/api/users/invite/' + this.user._id)
      .then(res => {
        if (res.status === 200) {
          // this.user.verified = true
          this.wait2 = false
          this.successMsg = 'Invitation sent'
          // utils.methods.delay(3000, () => { this.successMsg = '' })
        }
      })
      .catch(e => {
        this.error = e.response.data
        this.wait2 = false
      })
    },
    setPic (file) {
      this.newPic = file
    },
    savePic () {
      if (this.user.profile.avatar) {
        this.updateAvatar()
        return
      }
      axios.post('/api/users/avatars/set', {
        user: this.user._id,
        data: this.newPic
      }).then(res => {
        if (res.status === 200) {
          if (res.data) {
            // Expect the ObjectId of the new avatar
            this.user.profile.avatar = res.data
          }
          this.savingPic = false
          bus.$emit('new_avatar', this.user._id, this.newPic)
        }
      }).catch(e => {
        this.savingPic = false
        console.log(e.response.data)
      })
    },
    updateAvatar () {
      axios.post('/api/users/avatars/update', {
        _id: this.user.profile.avatar,
        user: this.user._id,
        data: this.newPic
      })
      .then(res => {
        if (res.status === 200) {
          this.savingPic = false
          bus.$emit('new_avatar', this.user._id, this.newPic)
        }
      })
      .catch(e => {
        this.savingPic = false
        console.log(e)
      })
    },
    getAgreements () {
      axios.get('/api/agreements/unlinked').then(res => {
        if (res.status === 200) this.agreements = res.data
      }).catch(e => { console.log(e.response.data) })
    },
    linkAgreement () {
      if (!this.newAgreement) return
      let form = new FormData()
      form.append('user', this.user._id)
      form.append('agreement', this.newAgreement)

      axios.post('/api/agreements/link', form)
      .catch(e => { this.error = e.respone.data })
    },
    unlinkAgreement () {
      let form = new FormData()
      form.append('user', this.user._id)
      form.append('agreement', this.user.agreement)
      axios.post('/api/agreements/unlink', form)
      .then(res => {
        if (res.status === 200) {
          this.user.agreement = null
          this.getAgreements()
        }
      })
      .catch(e => { this.error = e.response.data })
    },
    delAvatar () {
      axios.post('/api/users/avatars/delete/' + this.user._id)
      .then(res => {
        if (res.status === 200) {
          this.user.profile.avatar = ''
          bus.$emit('del_avatar', this.user._id)
        }
      })
      .catch(e => { console.log(e.response.data) })
    },
    toLevel (n) {
      this.user.level = n
      this.save()
    },
    archiveUser () { // works as a toggle
      this.wait1 = true
      axios.post('/api/users/archive/' + this.user._id)
      .then(res => {
        if (res.status === 200) {
          this.wait1 = false
          this.successMsg = 'Saved'
          this.user.archived = !this.user.archived
        }
      })
      .catch(e => {
        this.wait1 = false
        this.error = e.response.data
        utils.methods.delay(3000, () => { this.error = '' })
      })
    },
    getBrand () {
      if (!this.user.profile.brand) {
        return this.brands['pl'] // Default to PocketLegal
      }
      return this.brands[this.user.profile.brand]
    }
  }
}
</script>
<style scoped>
.adminControls {
  border-radius: 4px;
  padding: 1em;
  margin: 2em 0;
  background: rgba(63, 169, 245, 0.15);
}
</style>



// WEBPACK FOOTER //
// userProfile.vue?91214b5a